export default __webpack_public_path__ + "static/media/operations_personnel.918dcd51.svg";